<app-header></app-header>
<div class="main-layout">
  <app-sidebar></app-sidebar>
  <div class="content">
    <div class="header">
      <div class="custom-row">
        <div class="left-column">
          {{ "Welcome" | translate }}
          <b>{{ employeeName.firstname ? (employeeName.firstname + (employeeName.lastname ? ' ' + employeeName.lastname
            : '')) : employeeName.name }} {{ roleName }}</b> {{ currentTime }}
        </div>
        <div class="right-column" *ngIf="lastLogin">Last Login &#64; {{ lastLogin }}</div>
      </div>

      <div class="second_header">
        <div class="left-section">
          <div *ngIf="!hideBack" class="back-arrow" (click)="goback()">
            <i class="fa-solid fa-arrow-left"></i>
          </div>
          <div class="rightBorder" *ngIf="!hideBack"></div>
          <div>{{ breadcrumb }}</div>
        </div>
        <div class="right-section">
          <div class="icon home" (click)="goHome()">
            <i class="fa-solid fa-house"></i>
          </div>
          <span class="rightBorder"></span>
          <div class="icon" (click)="widgetSettings(mediacontent)">
            <img src="../../../assets/img/Settingicon.png" alt="Settings" />
          </div>
          <span class="rightBorder"></span>
          <div class="icon help"><i class="fa-solid fa-question"></i></div>
        </div>
      </div>
    </div>
    <div class="formcontent">
      <div class="formContainer">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<!-- Optional Footer -->
<!-- <app-footer></app-footer> -->

<ng-template #mediacontent let-modal>
  <div class="modal-header">
    <h5 class="modal-name title-head text-center m-0" id="modal-basic-name">
      Widget Settings
    </h5>
    <i class="fas fa-times close-icon" (click)="clearform()"></i>
  </div>

  <div class="modal-body master">
    <div class="form-group row">
      <app-custom-widgets></app-custom-widgets>
    </div>
  </div>
</ng-template>